export default [
  {
    path: "/pengguna/reviewer",
    component: () =>
      import("@/pages/user-management/reviewer/reviewer-list.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/pengguna/admin-blok",
    component: () =>
      import("@/pages/user-management/block-manager/block-manager-list.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/profil",
    component: () => import("@/pages/profile/Profil.vue"),
  },
  {
    path: "/login",
    component: () => import("@/pages/Login.vue"),
  },
  {
    path: "/forbidden",
    component: () => import("@/pages/Forbidden.vue"),
  },
  {
    path: "*",
    component: () => import("@/pages/NotFound.vue"),
  },
];
